import slug from '@teko/slug';
export { DiscoveryService, normalizePageBuilderToDiscoveryParams } from './service.es.js';
export { BlockAttribute, PageTypeEnum, Sorting } from './types.es.js';
export { useDiscoveryProduct, useDiscoverySearch, useInfiniteDiscoverySearch, usePersonalizeBlocks, useSkus } from './hooks.es.js';
export { SORT_ORDER, SORT_TYPE } from './constants.es.js';

const getProductUrl = (name, sku) => {
    return `/${slug(name)}--s${sku}?sku=${sku}`;
};

export { getProductUrl };
